import { connect } from "react-redux";
import React, { useEffect } from "react";

const WebXRGoogleModelViewer = (props) => {
  const { cabinetsGlb } = props;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js";
    script.type = "module";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!cabinetsGlb) {
    return null;
  }

  return (
    <div className={"sqft-ar"} style={{ position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 }}>
      <model-viewer
        id="arViewer"
        src={cabinetsGlb}
        ar
        ar-scale="fixed"
        camera-controls
        touch-action="pan-y"
        alt="A 3D model"
        shadow-intensity="2"
        max-camera-orbit="auto 90deg auto"
        xr-environment
        style={hiddenModelViewerStyle}
      >
      </model-viewer>
    </div>
  );
};

const hiddenModelViewerStyle = {
  display: 'block',
  width: '0',
  height: '0',
  position: 'absolute',
  top: '-9999px',
};

const mapStateToProps = (store) => ({
  isMobile: store.serverState.isMobile,
  cabinetsGlb: store.sqftState.cabinetsGlb,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WebXRGoogleModelViewer);
